var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompSlideBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 201,
    viewBox: "0 0 201 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.178 6.39209C152.273 6.39209 194.568 48.6865 194.568 100.781V166.171C194.568 182.187 181.584 195.171 165.568 195.171H5.78906V100.781C5.78906 48.6865 48.0834 6.39209 100.178 6.39209Z",
    stroke: "#E6EBF8",
    strokeWidth: 11.2584,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.99 66.0093C165.634 66.0093 194.572 94.9475 194.572 130.591V165.174C194.572 181.742 181.141 195.174 164.572 195.174H65.4082V130.591C65.4082 94.9475 94.3465 66.0093 129.99 66.0093Z",
    stroke: "#E6EBF8",
    strokeWidth: 11.2584,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.36 123.195C178.102 123.195 194.129 139.222 194.129 158.963V164.732C194.129 181.3 180.697 194.732 164.129 194.732H122.592V158.963C122.592 139.222 138.619 123.195 158.36 123.195Z",
    stroke: "#E6EBF8",
    strokeWidth: 11.2584,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompSlideBg);
export default __webpack_public_path__ + "static/media/comp-slide-bg.1399e16ddbcb8de395af5541b4988913.svg";
export { ForwardRef as ReactComponent };